import React, {useEffect, useState} from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from "@material-ui/core";
import PaymentDueToday from "./PaymentDueToday";
import RecurringMonthlyPayments from "./RecurringMonthlyPayments";
import { usePolicyContext } from "./PolicyContext";
import moment from "moment/moment";

const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                width: "100%",
                "&::before": {
                    height: 0,
                },
            },
            heading: {
                fontSize: theme.typography.pxToRem(15),
                flexBasis: "33.33%",
                flexShrink: 0,
            },
            secondaryHeading: {
                fontSize: theme.typography.pxToRem(15),
                color: theme.palette.text.secondary,
            },
            accordionWrap: {
                background: "#F1F5F9",
                padding: "15px",
                float: "left",
                width: "100%",
                marginBottom: 20,
            },
            mainAccordion: {
                float: "left",
                width: "100%",
                borderRadius:'4px !important',
                "&::before":{
                    height:"0 !important"
                }
            },
        }),
);

export default function PaymentBreakdownAccordion() {
    const classes = useStyles();
    const {policy} = usePolicyContext();
    const [futurePaymentDate, setFuturePaymentDate] = useState("");
    const [firstMonthPayment, setFirstMonthPayment] = useState(0);
    const [currentMonthPayment, setCurrentMonthPayment] = useState(0);
    const [ePayFee, setEPayFee] = useState(0);
    const [proRatedAmount, setProratedAmount] = useState(0);
    const [recurringPayments, setRecurringPayments] = useState<any>([]);
    useEffect(() => {
        if (policy && policy.paymentTimetableAnnual) {
            const timeTable: any = policy && policy.paymentTimetableAnnual || {};
            if (timeTable.switchPayment && timeTable.switchPayment.amount) {
                setCurrentMonthPayment(timeTable.switchPayment.amount[0].amount + timeTable.switchPayment.amount[1].amount);
                setEPayFee(timeTable.switchPayment.amount[2].amount);
                setFuturePaymentDate(timeTable.switchRecurring[0].date)
                setFirstMonthPayment(timeTable.switchRecurring[0].amount[0].amount + timeTable.switchRecurring[0].amount[1].amount + timeTable.switchRecurring[0].amount[2].amount)
                setRecurringPayments(timeTable.switchRecurring);
                setProratedAmount(timeTable.switchRecurring[0].amount[0].amount + timeTable.switchRecurring[0].amount[1].amount);
            }
        }
    }, [policy]);

    return (
            <div className={classes.root}>
                <div className={classes.accordionWrap}>
                    <Typography variant="subtitle2" component="strong" className="floatLeft w100 mb0">Total Due Today <span
                            className="floatRight">${currentMonthPayment+ePayFee}</span></Typography>
                    <Typography className="floatLeft w100 f14 mb15">Includes any pro-rated payments towards next years
                        contribution, trust and ePay processing fees.</Typography>
                    <ExpansionPanel className={classes.mainAccordion} style={{ float: "left", width: "100%" }}>
                        <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                        >
                            <Typography className={classes.heading + " mb0 "}>First Payment Breakdown</Typography>
                            <Typography className={classes.secondaryHeading + " mb0 "}>View an itemized list of
                                charges.</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <PaymentDueToday ePayFee={ePayFee} currentMonthPayment={currentMonthPayment} totalDueToday={currentMonthPayment+ePayFee} proRatedAmount={proRatedAmount}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div className={classes.accordionWrap}>
                    <Typography variant="subtitle2" component="strong" className="floatLeft w100 mb0">Recurring Monthly Payments <span className="floatRight">${firstMonthPayment}</span></Typography>
                    <Typography className="floatLeft w100 f14 mb15">Future payments begin on  {moment(futurePaymentDate).format("MM/DD/YYYY") + " "}</Typography>
                    <ExpansionPanel className={classes.mainAccordion} style={{ float: "left", width: "100%" }}>
                        <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                        >
                            <Typography className={classes.heading + " mb0 "}>Future Payment Breakdown</Typography>
                            <Typography className={classes.secondaryHeading + " mb0 "}>View future recurring monthly
                                payments.</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{overflow:"auto",maxHeight:'300px'}}>
                            <RecurringMonthlyPayments recurringPayments={recurringPayments}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            </div>
    );
}
